import './App.css';
import SeatMapWrapper from './components/SeatMapWrapper'
import Header from './components/Header'
import Footer from './components/Footer'


function App() {
  return (
    <div className="App">
      <Header/>
      <SeatMapWrapper/>
      <Footer/>
    </div>
  );
}

export default App;
